import { BaseBusinessUserIdPutRequest } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';

/**
 * update apiで使用するデータをUI用と変換する
 */
export class BulkUpdateBaseBusinessUserIdAdapter {
  /**
   * 客先内示担当者IDの編集APIのリクエストデータに変換
   * @param baseBusinessIds - 取引ID
   * @param userIds - 担当者ID
   */
  public static adaptForRequest = (baseBusinessIds: string[], userIds: string[]): BaseBusinessUserIdPutRequest => {
    return {
      targetBusinessIdList: baseBusinessIds,
      baseBusinessUserIdList: userIds,
    };
  };
}
